export default "__VITE_ASSET__CKh7VqFB__"